import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux-store/store-config';
import { Service } from 'types/service.types';

const getServices = (state: RootState): Service[] => state.servicesState.services;

export const selectServices = createSelector([getServices], (services) => services);
